import { FETCH_ANALYZE_DATA_REQUEST, DELETE_INTERACTIVE_REQUEST, CLONE_INTERACTIVE_REQUEST, FETCH_DETAILS_REQUEST, FETCH_ANALYZE_POINTS_REQUEST, CREATE_INTERACTIVE_REQUEST, FETCH_TEMPLATES_REQUEST, ARCHIVE_INTERACTIVES_REQUEST, UNPUBLISH_INTERACTIVE_REQUEST, FETCH_EMBED_CODE_REQUEST, FETCH_PREVIEW_PAGES_REQUEST, RUN_AB_TEST_REQUEST, PICK_AB_TEST_WINNER_REQUEST, GENERATE_AI_CTA_REQUEST } from '../utils/requestStateKeys';
import { requestStates } from 'redux-request-state';
import createReducer from 'redux-request-state/reducers/createReducer';
import * as actionTypes from '../actions/ActionTypes';
const {
  FAILED,
  STARTED,
  SUCCEEDED
} = requestStates;
const pickAbTestWinnerArtifactBuilders = {
  [actionTypes.PICK_AB_TEST_WINNER_STARTED]: () => ({
    requestKey: PICK_AB_TEST_WINNER_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.PICK_AB_TEST_WINNER_SUCCEEDED]: () => ({
    requestKey: PICK_AB_TEST_WINNER_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.PICK_AB_TEST_WINNER_FAILED]: ({
    error
  }) => ({
    requestKey: PICK_AB_TEST_WINNER_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const runAbTestArtifactBuilders = {
  [actionTypes.RUN_AB_TEST_STARTED]: () => ({
    requestKey: RUN_AB_TEST_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.RUN_AB_TEST_SUCCEEDED]: () => ({
    requestKey: RUN_AB_TEST_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.RUN_AB_TEST_FAILED]: ({
    error
  }) => ({
    requestKey: RUN_AB_TEST_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const cloneInteractiveArtifactBuilders = {
  [actionTypes.CLONE_INTERACTIVE_STARTED]: () => ({
    requestKey: CLONE_INTERACTIVE_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.CLONE_INTERACTIVE_SUCCEEDED]: () => ({
    requestKey: CLONE_INTERACTIVE_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.CLONE_INTERACTIVE_FAILED]: ({
    error
  }) => ({
    requestKey: CLONE_INTERACTIVE_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const deleteInteractiveArtifactBuilders = {
  [actionTypes.DELETE_INTERACTIVE_STARTED]: () => ({
    requestKey: DELETE_INTERACTIVE_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.DELETE_INTERACTIVE_SUCCEEDED]: () => ({
    requestKey: DELETE_INTERACTIVE_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.DELETE_INTERACTIVE_FAILED]: ({
    error
  }) => ({
    requestKey: DELETE_INTERACTIVE_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const createInteractiveArtifactBuilders = {
  [actionTypes.CREATE_INTERACTIVE_STARTED]: () => ({
    requestKey: CREATE_INTERACTIVE_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.CREATE_INTERACTIVE_SUCCEEDED]: () => ({
    requestKey: CREATE_INTERACTIVE_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.CREATE_INTERACTIVE_FAILED]: ({
    error
  }) => ({
    requestKey: CREATE_INTERACTIVE_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const archiveInteractivesArtifactBuilders = {
  [actionTypes.ARCHIVE_INTERACTIVE_SUCCEEDED]: () => ({
    requestKey: ARCHIVE_INTERACTIVES_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.ARCHIVE_INTERACTIVE_FAILED]: ({
    error
  }) => ({
    requestKey: ARCHIVE_INTERACTIVES_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const unpublishInteractiveArtifactBuilders = {
  [actionTypes.UNPUBLISH_INTERACTIVE_STARTED]: () => ({
    requestKey: UNPUBLISH_INTERACTIVE_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.UNPUBLISH_INTERACTIVE_SUCCEEDED]: () => ({
    requestKey: UNPUBLISH_INTERACTIVE_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.UNPUBLISH_INTERACTIVE_FAILED]: ({
    error
  }) => ({
    requestKey: UNPUBLISH_INTERACTIVE_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchAnalyzeDataArtifactBuilders = {
  [actionTypes.FETCH_ANALYZE_DATA_STARTED]: () => ({
    requestKey: FETCH_ANALYZE_DATA_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_ANALYZE_DATA_SUCCEEDED]: () => ({
    requestKey: FETCH_ANALYZE_DATA_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_ANALYZE_DATA_FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_ANALYZE_DATA_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchAnalyzePointsArtifactBuilders = {
  [actionTypes.FETCH_ANALYZE_POINTS_STARTED]: () => ({
    requestKey: FETCH_ANALYZE_POINTS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_ANALYZE_POINTS_SUCCEEDED]: () => ({
    requestKey: FETCH_ANALYZE_POINTS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_ANALYZE_POINTS_FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_ANALYZE_POINTS_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchDetailsArtifactBuilders = {
  [actionTypes.FETCH_DETAILS.STARTED]: () => ({
    requestKey: FETCH_DETAILS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_DETAILS.SUCCEEDED]: () => ({
    requestKey: FETCH_DETAILS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_DETAILS.FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_DETAILS_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchTemplatesArtifactBuilders = {
  [actionTypes.FETCH_TEMPLATES_STARTED]: () => ({
    requestKey: FETCH_TEMPLATES_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_TEMPLATES_SUCCEEDED]: () => ({
    requestKey: FETCH_TEMPLATES_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_TEMPLATES_FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_TEMPLATES_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchEmbedCodeArtifactBuilders = {
  [actionTypes.FETCH_EMBED_CODE_STARTED]: () => ({
    requestKey: FETCH_EMBED_CODE_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_EMBED_CODE_SUCCEEDED]: () => ({
    requestKey: FETCH_EMBED_CODE_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_EMBED_CODE_FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_EMBED_CODE_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const fetchPreviewPagesAritfactBuilders = {
  [actionTypes.FETCH_PREVIEW_PAGES.STARTED]: () => ({
    requestKey: FETCH_PREVIEW_PAGES_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_PREVIEW_PAGES.SUCCEEDED]: () => ({
    requestKey: FETCH_PREVIEW_PAGES_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_PREVIEW_PAGES.FAILED]: ({
    error
  }) => ({
    requestKey: FETCH_PREVIEW_PAGES_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const generateAiCtaArtifactBuilders = {
  [actionTypes.GENERATE_AI_CTA_STARTED]: () => ({
    requestKey: GENERATE_AI_CTA_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.GENERATE_AI_CTA_SUCCEEDED]: () => ({
    requestKey: GENERATE_AI_CTA_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.GENERATE_AI_CTA_FAILED]: ({
    error
  }) => ({
    requestKey: GENERATE_AI_CTA_REQUEST,
    requestState: FAILED,
    fatalError: error
  })
};
const baseArtifactBuilderLookup = Object.assign({}, fetchAnalyzeDataArtifactBuilders, pickAbTestWinnerArtifactBuilders, runAbTestArtifactBuilders, cloneInteractiveArtifactBuilders, deleteInteractiveArtifactBuilders, archiveInteractivesArtifactBuilders, unpublishInteractiveArtifactBuilders, fetchDetailsArtifactBuilders, fetchAnalyzePointsArtifactBuilders, createInteractiveArtifactBuilders, fetchTemplatesArtifactBuilders, fetchEmbedCodeArtifactBuilders, fetchPreviewPagesAritfactBuilders, generateAiCtaArtifactBuilders);
const createRequestStatesReducer = () => {
  const getArtifactFromAction = action => {
    const buildArtifactFromAction = baseArtifactBuilderLookup[action.type];
    return buildArtifactFromAction && buildArtifactFromAction(action) || null;
  };
  // The library declares action to be of type `ActionLike` which doesn't match our actions hence the casting
  return createReducer(getArtifactFromAction);
};
export default createRequestStatesReducer();